// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"login_loading_background__1hFpd","loading_img":"login_loading_img__3n1EJ","svg":"login_svg__IZgfz"};